import { useMemo, useState } from 'react';
import * as R from 'remeda';
import { useIntl } from 'react-intl';
import { Box, Stack, Typography } from '@rossum/ui/material';

const MAX_MESSAGE_LENGTH = 220;

type MessageProps = {
  message: string;
};

export const Message = ({ message }: MessageProps) => {
  const [messageIsExpanded, setMessageIsExpanded] = useState(false);

  const intl = useIntl();

  const isMessageTruncated = message.length > MAX_MESSAGE_LENGTH;

  const truncatedMessage = useMemo(
    () =>
      isMessageTruncated
        ? R.truncate(message, MAX_MESSAGE_LENGTH, { omission: '...' })
        : message,
    [isMessageTruncated, message]
  );

  if (message.length === 0) return null;

  return (
    <Stack>
      <Typography variant="caption" color="secondary">
        {intl.formatMessage({
          id: 'features.activities.rows.message.title',
        })}
      </Typography>
      <Typography maxWidth={650} variant="body2">
        {messageIsExpanded ? message : truncatedMessage}
        {isMessageTruncated ? (
          <Box
            component="span"
            onClick={() => setMessageIsExpanded(!messageIsExpanded)}
            sx={{
              color: 'text.secondary',
              ml: 0.5,
              cursor: 'pointer',
              fontWeight: 600,
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            {intl.formatMessage({
              id: `features.activities.rows.message.${messageIsExpanded ? 'less' : 'more'}`,
            })}
          </Box>
        ) : null}
      </Typography>
    </Stack>
  );
};
